import {
  AppointmentParticipant,
  AppointmentParticipantDetail,
} from "./appointmentParticipantTypes";

export function hasContactAccess(participant: AppointmentParticipant): boolean {
  return (
    participant.email !== undefined || participant.phoneNumber !== undefined
  );
}

export function mapInviteeToParticipant(inv: {
  invitee?: {
    firstName?: string | null;
    lastName?: string | null;
    subjectId?: string | null;
    groupCode?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
  };
}): AppointmentParticipant | null {
  const invitee = inv?.invitee;
  if (!invitee) return null;

  const firstName = invitee.firstName || "";
  const lastName = invitee.lastName || "";
  const displayId =
    invitee.subjectId && invitee.groupCode
      ? `${invitee.subjectId} - ${invitee.groupCode}`
      : invitee.subjectId || invitee.groupCode || "";
  const name =
    `${firstName} ${lastName}`.trim() || displayId || "Name Unknown";

  if (!name) return null;

  const participant: AppointmentParticipant = { name };

  if (invitee.email !== undefined) {
    participant.email = invitee.email;
  }
  if (invitee.phoneNumber !== undefined) {
    participant.phoneNumber = invitee.phoneNumber;
  }

  return participant;
}

export function mapInviteesToParticipants(
  invitees: Array<Parameters<typeof mapInviteeToParticipant>[0]> | undefined,
): AppointmentParticipant[] {
  return (
    invitees
      ?.map(mapInviteeToParticipant)
      .filter((p): p is AppointmentParticipant => p !== null) || []
  );
}

export function mapSlotInviteeToDetail(inv: {
  invitee?: {
    id?: string;
    firstName?: string | null;
    lastName?: string | null;
    subjectId?: string | null;
    groupCode?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    cohortId?: string | null;
    cohortName?: string | null;
  };
}): AppointmentParticipantDetail | null {
  const base = mapInviteeToParticipant(inv);
  const invitee = inv?.invitee;
  if (!base || !invitee?.id) return null;

  const firstName = invitee.firstName || "";
  const lastName = invitee.lastName || "";
  const subjectId = invitee.subjectId || "";
  const groupCode = invitee.groupCode || "";

  return {
    ...base,
    id: invitee.id,
    cohortId: invitee.cohortId || "",
    cohortName: invitee.cohortName || "",
    code:
      firstName || lastName
        ? subjectId && groupCode
          ? `${subjectId} - ${groupCode}`
          : subjectId || groupCode || ""
        : "",
  };
}

export function mapSlotInviteesToDetails(
  invitees: Array<Parameters<typeof mapSlotInviteeToDetail>[0]> | undefined,
): AppointmentParticipantDetail[] {
  return (
    invitees
      ?.map(mapSlotInviteeToDetail)
      .filter((p): p is AppointmentParticipantDetail => p !== null) || []
  );
}
